import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { RewardsTransactionExportModal } from './RewardsTransactionExportModal'

interface RewardsTransactionExportProps {
  walletId: string
}

export const RewardsTransactionExport = ({ walletId }: RewardsTransactionExportProps) => {
  const { t } = useTranslation()

  const [showCustomDateExportModal, setShowCustomDateExportModal] = useState(false)

  const handleClose = () => {
    setShowCustomDateExportModal(false)
  }

  return (
    <>
      {showCustomDateExportModal && (
        <RewardsTransactionExportModal handleClose={handleClose} walletId={walletId} />
      )}
      <Button
        variant="secondary"
        iconElement={<Icon name="DownloadSimple" />}
        onClick={() => setShowCustomDateExportModal(true)}
        testId="export-rewards-transactions-btn"
      >
        {t('export')}
      </Button>
    </>
  )
}
